import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import './DexaReports.scss';
import DexaReportsTable from './DexaReportsTable';
import UploadModal from './UploadModal';

const DexaReports: React.FC = () => {
  const [totalCount, setTotalCount] = useState<number>(0);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState<boolean>(false);
  const [refreshKey, setRefreshKey] = useState<number>(0);
  const assigned_doctor = JSON.parse(sessionStorage.getItem('assigned_doctor') ?? 'false');
  const {
    admin: { role }
  } = useSelector((state: RootState) => state.admin);
  const isReadOnly = role === 'doctor' && !assigned_doctor;

  return (
    <div className='dexa-reports'>
      <div className='dexa-reports-header sideBarPad2'>
        <h2 className='dexa-reports-title'>DEXA Reports ({totalCount})</h2>
        {!isReadOnly && (
          <button className='upload-button' onClick={() => setIsUploadModalOpen(true)}>
            <span className='upload-icon'>+</span>
            Upload
          </button>
        )}
      </div>
      <div className='dexa-reports-container'>
        <DexaReportsTable key={refreshKey} onCountUpdate={setTotalCount} />
      </div>

      <UploadModal
        isOpen={isUploadModalOpen}
        onClose={() => setIsUploadModalOpen(false)}
        onUploadSuccess={() => setRefreshKey((prev) => prev + 1)}
      />
    </div>
  );
};

export default DexaReports;
